import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Paper } from '@mui/material';
import FormEstudante from '../../components/Estudantes/FormEstudante';
import { criarEstudante, obterEstudante, atualizarEstudante } from '../../services/estudanteService';

const CriarEditarEstudantePage = () => {
  const [estudante, setEstudante] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode) {
      const fetchEstudante = async () => {
        try {
          const data = await obterEstudante(id);
          setEstudante(data);
        } catch (error) {
          console.error('Erro ao buscar estudante:', error);
          // TODO: Adicionar tratamento de erro e feedback ao usuário
        }
      };

      fetchEstudante();
    }
  }, [id, isEditMode]);

  const handleSubmit = async (formData) => {
    try {
      if (isEditMode) {
        await atualizarEstudante(id, formData);
      } else {
        await criarEstudante(formData);
      }
      navigate('/estudantes');
    } catch (error) {
      console.error('Erro ao salvar estudante:', error);
      // TODO: Adicionar tratamento de erro e feedback ao usuário
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        {isEditMode ? 'Editar Estudante' : 'Criar Novo Estudante'}
      </Typography>
      <FormEstudante 
        onSubmit={handleSubmit} 
        estudanteInicial={estudante}
      />
    </Paper>
  );
};

export default CriarEditarEstudantePage;